import { useState, useEffect, useCallback } from 'react';
import * as api from '../services/api';

const INITIAL_FILTERS = {
  yearFrom: null,
  yearTo: null,
  country: '',
  tradingCountry: '',
  valueMin: '',
  valueMax: '',
  weightMin: '',
  weightMax: '',
  trademark: '',
  importer: '',
  exporter: '',
  productCodePrefix: '',
};

/**
 * Manages filter state and loads filter metadata from API.
 */
export function useFilters() {
  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const [countries, setCountries] = useState([]);
  const [years, setYears] = useState([]);
  const [loadingMeta, setLoadingMeta] = useState(false);

  // Load filter metadata on mount
  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoadingMeta(true);
      try {
        const [countriesData, yearsData] = await Promise.all([
          api.getCountries(150),
          api.getYears(),
        ]);
        if (!cancelled) {
          setCountries(countriesData || []);
          setYears(yearsData || []);
        }
      } catch (err) {
        console.error('Failed to load filter metadata:', err);
      } finally {
        if (!cancelled) setLoadingMeta(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const updateFilter = useCallback((key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  }, []);

  const clearFilters = useCallback(() => {
    setFilters(INITIAL_FILTERS);
  }, []);

  const hasActiveFilters = Object.values(filters).some(v => v !== null && v !== '' && v !== undefined);

  const activeFilterCount = Object.values(filters).filter(v => v !== null && v !== '' && v !== undefined).length;

  return {
    filters,
    countries,
    years,
    loadingMeta,
    updateFilter,
    clearFilters,
    hasActiveFilters,
    activeFilterCount,
  };
}
